import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { getV1OrganizationsByOrganizationIdAssignmentsOptions } from "../../../client/@tanstack/react-query.gen";

export const getAssignmentsOptions = (organizationID: string) =>
  queryOptions({
    ...getV1OrganizationsByOrganizationIdAssignmentsOptions({
      path: { organizationID },
    }),
    staleTime: 1000 * 60 * 5,
  });

export const getAssignmentsQueryKey = (organizationID: string) =>
  getAssignmentsOptions(organizationID).queryKey;

export const useGetAssignments = (organizationID: string) => {
  return useSuspenseQuery(getAssignmentsOptions(organizationID));
};
